import type { PlayerUser } from '../../entities/user/types';

export function chatwootContactName(user: PlayerUser): string {
  const country = String(user.country_code || '').trim().toUpperCase();
  const rawId = String(user.display_id || user.displayId || '').trim().toUpperCase();
  const id = rawId.startsWith('S') ? rawId : `S${rawId}`;
  if (/^[A-Z]{2}$/.test(country) && /^S[0-9]{8}$/.test(id)) return `Sorteia-${country}-${id}`;
  return String(user.username || user.name || 'Jogador Sorteia');
}
